export default __webpack_public_path__ + "static/media/faq_lief.d693539d.svg";